import { TTagType } from '@monorepo/types';

export const CUTBANKHELPER_UTIL = {
  getDisplayTagIdFromScannedTag: (decodedQrData: Record<string, string>): string => {
    return decodedQrData['did'];
  },

  validateTagId(tagId: string, tagType: TTagType): boolean {
    // per-piece tag id starts with 2 digit(example: 213699670500)
    // component tag id starts with 3 digit(example: 31961923020
    // Bundle-tag id starts with 1 digit(example: 113070096410)
    if (!tagId.length) return false;
    const firstDigit = tagId.charAt(0);
    if (tagType === TTagType.MASTER_BUNDLE_TAG) {
      return firstDigit === '1';
    } else if (tagType === TTagType.COMPONENT_BUNDLE_TAG) {
      return firstDigit === '3';
    } else if (tagType === TTagType.PER_PIECE_TAG) {
      return firstDigit === '2';
    }
    return false;
  },
};
